module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAYAAAC0EpUuAAAAAXNSR0IArs4c6QAAAKlJREFUOBHt0E0KwjAQBeB5IUnxpwiCC2/jyvuIezeexCO4Sz1Dt4LdFkEURKS0mEQalzlAxl1n9RiYb+ChKIpJ62lPXCNwlE7rUXB2w2Ui4CqnRJ8XcOBCRcCZyxqcPzcAY8y8/dKF6w8gdtJnmSBvF1wogcZymefvunNrLlRpVFzW4MQGUJalqu/PVVylJaVFJW9NMwt9OKVR8dq7sJXK2t4THnGdnLofc0w0E5QFCB8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dragIcon.png
// module id = uDNb
// module chunks = 3